// This file is automatically compiled by Vite, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// https://github.com/tc39/proposal-explicit-resource-management を使うためのpolyfill
// TODO: 主要ブラウザーで実装されたら削除する
import "core-js/proposals/explicit-resource-management";

import { configure } from "mobx";

configure({
  enforceActions: "never",
});

import "bundles/Notification/startup/NotificationApp";
import "bundles/RawPostViewer/startup/RawPostViewerApp";
import "bundles/EventMasterEditor/startup/EventMasterEditorApp";
import "bundles/UserTitleRoleEditor/startup/UserTitleRoleEditorApp";
import "bundles/BigqueryQueryViewer/startup/BigqueryQueryViewerApp";
import "bundles/BigqueryTableViewer/startup/BigqueryTableViewerApp";
import "bundles/BigqueryQueryJobsStatsViewer/startup/BigqueryQueryJobsStatsViewerApp";
import "bundles/RoleDescriptionViewer/startup/RoleDescriptionViewerApp";
import "bundles/QueryHistoryViewer/startup/QueryHistoryViewerApp";
import "bundles/MonacoEditor/startup/MonacoEditorApp";
import "bundles/DateTimePicker/startup/DateTimePickerApp";
import "bundles/VersionNoteEditor/startup/VersionNoteEditorApp";
import { renderComponents } from "lib/components";

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    renderComponents();
  });
} else {
  renderComponents();
}
